import React from "react";
import { useLocation } from "react-router-dom";

import { SideNavContent, SideNav } from "components";
import { HeaderDasNew, Ptag } from "components/core";
import { HomeWrapper } from "./styles";
import EndorsementHistoryEdit from "pages/EndorsementHistoryEdit";

const UploadEndorsement = () => {
  const { state } = useLocation();
  const business_user_id = localStorage.getItem("id");
  const company_name = localStorage.getItem("company_name");

  return (
    <>
      <SideNav>{business_user_id && <SideNavContent />}</SideNav>
      <HeaderDasNew company_name={company_name} />
      <HomeWrapper>
        <EndorsementHistoryEdit detail={state} />
      </HomeWrapper>
    </>
  );
};

export default UploadEndorsement;
